import { useForm } from "react-hook-form";
import { useEffect } from "react";

import { Box, Button, Container, Paper, Typography } from "@mui/material";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import {
  useCompanySteps,
  useHandlePageTraversal,
} from "../../../../common/hooks";
import { CompaniesStep, RoutePaths } from "../../../consts/enums";
import { HookedCheckbox } from "../../../components/HookedCheckbox";
import { HookedForm } from "../../../components/HookedForm";
import { LocationsOptions } from "../../../consts/consts";
import { EventName, trackEvent } from "../../../../common/utils/helpers";

export const SellerLocation = () => {
  const { id: startupId } = useParams();
  if (startupId === undefined) {
    return <Navigate to="/dashboard" replace={true} />;
  }
  const { data, isLoading, isError } = useCompanySteps(
    CompaniesStep.STARTUP,
    startupId
  );
  const navigate = useNavigate();
  const formHook = useForm();
  const { handleNext } = useHandlePageTraversal(formHook, Number(startupId));

  useEffect(() => {
    if (data && !isLoading) {
      formHook.reset({ ...data });
    }
  }, [data, isLoading]);

  if (isError) {
    return <Navigate to="/dashboard" replace={true} />;
  }

  return (
    <Box
      sx={{
        backgroundColor: "common.black",
        backgroundImage: "url(/images/BiggerGradient.png)",
        backgroundSize: "cover",
        backgroundPosition: "right",
        backgroundRepeat: "no-repeat",
        width: "100%",
        minHeight: "100%",
      }}
    >
      <Container
        maxWidth="md"
        sx={{
          height: "100%",
          padding: 4,
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
        }}
      >
        <Box>
          <Typography variant="h3" sx={{ color: "white" }}>
            Complete your company profile - this process takes 3 minutes
          </Typography>
          <Typography variant="subtitle1" sx={{ color: "common.grayOpacity" }}>
            List your company profile anonymously and start receiving messages
            from interested buyers
          </Typography>
          <Paper
            variant="outlined"
            elevation={2}
            sx={{ marginTop: 4, padding: 3 }}
          >
            <Typography variant="h3" sx={{ marginBottom: 1 }}>
              What region does your business operate in?
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "common.gray", marginBottom: 2 }}
            >
              Select all that apply
            </Typography>
            <HookedForm formHook={formHook}>
              <HookedCheckbox
                name="operating_regions"
                options={LocationsOptions}
              />
            </HookedForm>
          </Paper>
          <Box
            sx={{
              textAlign: "right",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Button
              onClick={() =>
                handleNext(
                  RoutePaths.REGISTER_SELLER + `/${startupId}/financials`
                )
              }
              sx={{ marginTop: 2 }}
              variant="roundsecondary"
            >
              Back
            </Button>
            <Button
              onClick={() =>
                handleNext(
                  RoutePaths.REGISTER_SELLER + `/${startupId}/post-acquisition`
                )
              }
              sx={{ marginTop: 2 }}
              variant="roundgradient"
            >
              Save &amp; Continue
            </Button>
          </Box>
        </Box>
        <Box
          sx={{
            display: { xs: "flex", md: "block" },
            flexDirection: "column",
            marginTop: 8,
          }}
        >
          <Typography
            variant="body2"
            fontWeight={700}
            color="white"
            sx={{ marginBottom: 1 }}
          >
            Just want to enter the marketplace?
          </Typography>
          <Typography
            variant="body2"
            color="common.gray"
            sx={{ marginBottom: 2 }}
          >
            Come back later to complete your Seller Profile.
          </Typography>
          <Button
            variant="roundprimary"
            onClick={() => {
              trackEvent(EventName.SKIP_SIGN_UP);
              navigate(RoutePaths.YOU_ACQUISITION);
            }}
          >
            <span>Skip</span>
          </Button>
        </Box>
      </Container>
    </Box>
  );
};
